module.exports = "/_next/static/images/mobilelocation-duotone-0d7de0a0fa1125ff896d14c846c50d94.svg";